<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="Подключение">
        <app-user-managmet></app-user-managmet>
    </mat-tab>
    <mat-tab label="Настройки">
        <app-properties></app-properties>
    </mat-tab>

</mat-tab-group>